import { useToast } from "@/components/hooks/use-toast";
import { MenuItem } from "@/components/ui/menu";
import { Post } from "@/lib/types";
import { atUriToBskyUrl } from "@/lib/utils";

export function CopyUserDidMenuItem({ post }: { post: Post }) {
  const { toast } = useToast();

  return (
    <MenuItem
      onSelect={() => {
        navigator.clipboard
          .writeText(post.author.did)
          .then(() =>
            toast({
              title: "Copied to clipboard",
            }),
          )
          .catch(console.error);
      }}
    >
      Copy User DID
    </MenuItem>
  );
}

export function CopyLinkMenuItem({ post }: { post: Post }) {
  const { toast } = useToast();

  return (
    <MenuItem
      onSelect={() => {
        navigator.clipboard
          .writeText(atUriToBskyUrl(post.uri))
          .then(() =>
            toast({
              title: "Copied to clipboard",
            }),
          )
          .catch(console.error);
      }}
    >
      Copy Link to Post
    </MenuItem>
  );
}
